import { useState } from "react";

import { Popup } from "@/Common/Components/Modals/Popup";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

interface PatientCommunicationDeletionPopupProps {
    onSubmit: () => void;
    onCancel: () => void;
}

function PatientCommunicationDeletionPopup(props: Readonly<PatientCommunicationDeletionPopupProps>): JSX.Element {
    const [isLoading, setIsLoading] = useState(false);
    const { getText } = useTranslation();
    const {
        onSubmit,
        onCancel
    } = props;

    function onAccept(): void {
        setIsLoading(true);
        onSubmit();
    }

    return (
        <Popup
            Id="patientCommunicationDeletionPopupMenu"
            title={getText("WarningLabel")}
            onCloseDelegate={onCancel}
            draggable={true}
            width={550}
            centeredHorizontally={true}
        >
            <div className="p-body" data-cy="patientCommunication-Deletion-popup">
                <div className="row stack-buffer">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="divlabel">
                            <label className="no-margin">
                                {getText("PatientCommunicationDeletionLabel")}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="p-footer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                        <button
                            data-action="cancel"
                            className="btn btn-default push-right-5"
                            onClick={onCancel}
                        >
                            {getText("CancelLabel")}
                        </button>
                        <button
                            data-cy="patientCommunication-Deletion-popup-confirm"
                            className="btn btn-danger"
                            disabled={isLoading}
                            onClick={onAccept}
                        >
                            {getText("DeleteLabel")}
                        </button>
                    </div>
                </div>
            </div>
        </Popup>
    );
}

export { PatientCommunicationDeletionPopup };
